import { render, staticRenderFns } from "./GivesPoints.vue?vue&type=template&id=a1e92196&scoped=true"
import script from "./GivesPoints.vue?vue&type=script&lang=js"
export * from "./GivesPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e92196",
  null
  
)

export default component.exports